module.exports = __webpack_public_path__ + "static/img/The Sun.90f9553.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/planet/The Sun.svg
// module id = 1417
// module chunks = 0